import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBannerImageAbove = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 36.715 48.953",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Bilde_over_Banner",
		"data-name": "Bilde over_Banner",
		d: "M8693.081,22832.955a4.089,4.089,0,0,1-4.08-4.08v-40.793a4.089,4.089,0,0,1,4.08-4.08h28.555a4.089,4.089,0,0,1,4.08,4.08v40.793a4.089,4.089,0,0,1-4.08,4.08Zm-2.04-44.873v40.793a1.925,1.925,0,0,0,2.04,2.041h28.555a1.926,1.926,0,0,0,2.04-2.041v-40.793a1.926,1.926,0,0,0-2.04-2.041h-28.555A1.925,1.925,0,0,0,8691.041,22788.082Zm7.141,37.652v-2.039h18.354v2.039Zm0-6.119v-2.039h18.354v2.039Zm-.769-6.842a2.057,2.057,0,0,1-1.994-1.994v-19.891a2.046,2.046,0,0,1,1.994-1.988H8717.3a2.048,2.048,0,0,1,1.994,1.988v19.891a2.059,2.059,0,0,1-1.994,1.994Zm1.856-5.209h16.212l-4.871-6.5-4.378,5.668-3.083-4.207Z",
		transform: "translate(-8689.001 -22784.002)"
	})
});
export default SvgBannerImageAbove;
